import Swiper from 'swiper';
import Section from '../Section';
import { A11y, Autoplay } from 'swiper/modules';

export default class TextAdverts extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    const swiperContainer = this.element.querySelector('.swiper');
    this.swiper = new Swiper(swiperContainer, {
      modules: [A11y, Autoplay],
      slidesPerView: 1,
      watchOverflow: true,
      autoHeight: true,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      speed: 1000,
    });
  }

}
